const R = require('ramda');

const renameKey = (src, dest) =>
	R.pipe(R.over(R.lens(R.prop(src), R.assoc(dest)), R.identity), R.dissoc(src));

module.exports = {renameKey};
